import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
// ==============================|| HOOKS - AUTH ||============================== //

export default function useAuth() {
    const context = useContext(AuthContext);

    if (!context) throw new Error('context must be use inside provider');

    return context;
}
